export default [
    {
        path: 'ac',
        name: 'access-control',
        meta: {
            title: 'project_menu.access_control',
        },
        component: () => import('@/views/Project/access/views/index.vue'),
    },
]
